// localStorage.ts

import { AuthTokens } from "@features/DiscordAuth/model/types";

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('auth_tokens');
    if (!serializedState) return null;
    
    return JSON.parse(serializedState);
  } catch (err) {
    console.error('Ошибка при загрузке состояния:', err);
    return null;
  }
};

export const saveState = (state: AuthTokens) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('auth_tokens', serializedState);
  } catch (err) {
    console.error('Ошибка при сохранении состояния:', err);
  }
};